@if (environment.maintenanceMode) {
  <main class="maintenance-page">
    <div class="maintenance-artwork">
      <img
        src="assets/images/scheduled-maintainance.png?v=2026-09-16"
        alt="Scheduled maintenance"
      />
      <span
        class="maintenance-duration"
        [attr.aria-label]="environment.maintenanceHours"
      >
        {{ environment.maintenanceHours }}
      </span>
    </div>
  </main>
} @else {
  @if (stateService.guideLayerShow) {
    <div class="guideLayer"></div>
  }
  <router-outlet> </router-outlet>
  <p-toast
    position="bottom-right"
    [preventOpenDuplicates]="true"
    key="downloadToast"
    styleClass="download-toast"
  >
    <ng-template let-message pTemplate="message">
      <app-toast-download
        (closeIconClicked)="closeDownloadToast()"
        style="width: 100%"
      >
      </app-toast-download>
    </ng-template>
  </p-toast>
  <p-toast
    position="bottom-right"
    [preventOpenDuplicates]="true"
    key="softWarningToast"
    [styleClass]="'planogram-toast ' + toastMarginClass"
  >
    <ng-template let-message pTemplate="message">
      <app-soft-warning-toast
        (closeIconClicked)="closeSoftWarningToast()"
        [message]="message.detail"
        style="width: 100%"
      ></app-soft-warning-toast>
    </ng-template>
  </p-toast>
  <p-toast
    position="bottom-right"
    [preventOpenDuplicates]="true"
    key="abi-nps-survey"
  ></p-toast>
}
